var handle;
jQuery(document).ready(function($){
    $('.dropdown div.arrow').click(function(event) {
        $(this).siblings('select').attr('selected', 'selected');
    });
    function convertToDollar(amount) {
        // var amount = parseInt(amount);
        var newAmount;
        if (amount.toString().length > 2) {
            newAmount = '$ ' + amount.toString().slice(0, -2) + '.' + amount.toString().slice(-2);
        } else {
            newAmount = '$ 0.' + amount;
        }
        return newAmount;
    }
    function selectOnChange() {
        $('#variant').change(function(event) {
            var myVariant = $(this).val();
            var url = '/products/' + handle + '.js';
            $.ajax({
                type: 'GET',
                url: url,
                dataType: 'json',
                success: function(data) {
                    $.each(data.variants, function(index, variant) {
                        if (myVariant == variant.id) {
                            if (variant.featured_image) {
                                $('#product-space .half-img img').attr('src', variant.featured_image.src);
                            };

                            $('#product-space .price .amount').html(convertToDollar(variant.price));
                            if (parseInt(variant.compare_at_price) > parseInt(variant.price) ) {
                                $('#product-space .price .compare').html(convertToDollar(variant.compare_at_price));
                            } else {
                                $('#product-space .price .compare').html("");
                            }

                            $('.dropdown #quantity').html('<option value="1">1</option>');
                            if (!variant.inventory_management) {
                                for (var i = 2; i <= 10 ; i++) {
                                    var tag = '<option value="' + i + '">'+ i + '</option>';
                                    $('.dropdown #quantity').append(tag);
                                }
                            } else {
                                var i = 2;
                                while (i <= 10 && i <= parseInt(variant.inventory_quantity)) {
                                    var tag = '<option value="' + i + '">'+ i + '</option>';
                                    $('.dropdown #quantity').append(tag);
                                    i++;
                                }
                            }
                        };
                    });
                },
                error: function() {
                    console.log('error');
                }
            });
        });
    }
    $('#add-items').on('click', function(event) {
        event.preventDefault;
        var variant = $('#variant').val();
        var quantity = $('#quantity').val();
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                    quantity: quantity,
                    id: variant
                },
            success: function() {
                var name = $('div.half-title h1').html();
                var theVariant = "";
                if ($("#variant option:selected").text() != "Default Title") {
                    theVariant = ' - ' + $( "#variant option:selected" ).text();
                };

                $('span#cart-count').html( parseInt($('span#cart-count').html()) + parseInt(quantity) );
                $('#product-space div.add-to-cart').attr('data-cart', 'You added ' + quantity + ' ' + name + theVariant + ' to your cart.');
                $('#product-space div.add-to-cart').addClass('show');
                setTimeout(function (){
                    $('#product-space div.add-to-cart').removeClass('show');
                    $('.add-to-cart').append('<a href="/cart">Go to Cart</a>');
                }, 3000);
            },
            error: function() {
                console.log('error');
            }
        });
    });

    $('.product').on('click', function(event) {
        var image, desc, price, compare, title;
        handle = $(this).attr('data-handle');
        var url = '/products/' + handle + '.js';
        $('#variant').html("");
        $.ajax({
            type: 'GET',
            url: url,
            dataType: 'json',
            success: function(data) {
                // console.log(data);
                image = data.featured_image;
                desc = data.description;
                price = data.variants[0].price;
                compare = data.compare_at_price_max;
                title = data.title;

                var insert = '<div class="dropdown for-variant"><label for="variant">Variant:</label><div class="select-wrap"><select id="variant">';
                $.each(data.variants, function(index, val) {
                    if (parseInt(val.inventory_quantity) >= 1) {
                        insert = insert + '<option value="' + val.id + '">' + val.title + '</option>';
                    } else {
                        insert = insert + '<option value="' + val.id + '" disabled>' + val.title + '</option>';
                    }
                });
                $('#product-space .selects .for-variant').remove();
                insert = insert + '</select></div></div>';
                $('#product-space div.selects').prepend(insert);
                if (data.variants.length < 2) {
                    $('.for-variant').addClass('invisible');
                } else {
                    $('.for-variant').removeClass('invisible');
                }

                $('.dropdown #quantity').html('<option value="1">1</option>');
                if (!data.variants[0].inventory_management) {
                    for (var i = 2; i <= 10 ; i++) {
                        var tag = '<option value="' + i + '">'+ i + '</option>';
                        $('.dropdown #quantity').append(tag);
                    }
                } else {
                    var i = 2;
                    while (i <= 10 && i <= parseInt(data.variants[0].inventory_quantity)) {
                        var tag = '<option value="' + i + '">'+ i + '</option>';
                        $('.dropdown #quantity').append(tag);
                        i++;
                    }
                }

                $('#product-space .half-title h1').html(title);
                $('#product-space .half-title p').html(desc);
                $('#product-space .half-img').html('<img class="img" src="' + image + '">');
                $('#product-space .price .amount').html(convertToDollar(price));
                if (compare) {
                    $('#product-space .price .compare').html(convertToDollar(compare));
                } else {
                    $('#product-space .price .compare').html("");
                }
                $('#product-space .add-to-cart').fadeIn();
                selectOnChange();
            },
            error: function() {
                console.log('error');
            }
        });

        $(this).addClass('active');
        $(this).siblings().removeClass('active');
    });
    $('#collection .row.products .product:first-child').click();
});
